import { render, staticRenderFns } from "./VIntersectionObserver.vue?vue&type=template&id=4a719cf6"
import script from "./VIntersectionObserver.vue?vue&type=script&lang=ts"
export * from "./VIntersectionObserver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports